import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDownIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.3599 4.1637V16.6463",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.1851 11.6532L10.3599 17.4784L4.53467 11.6532",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgArrowDownIcon;
